const getAvailableSessionExtensionTimes = (
  time,
  slotLength,
  breakLength,
  direction = "before",
  limit = 20,
) => {
  const blockLength = slotLength + breakLength
  const times = []

  let nextTime = time.clone()

  for (let i = 0; i < limit; i++) {
    nextTime =
      direction === "before"
        ? nextTime.subtract(blockLength, "minutes")
        : nextTime.add(blockLength, "minutes")

    if (!nextTime.isSame(time, "day")) break

    times.push(nextTime.clone())
  }

  return times
}

export default getAvailableSessionExtensionTimes